import react from "../svgs/react.svg";
import node from "../svgs/node.svg";
import next from "../svgs/next.svg";
import python from "../svgs/python.svg";
import mongodb from "../svgs/mongodb.svg";
import js from "../svgs/js.svg";
import sql from "../svgs/sql.svg";
import blender from "../svgs/blender.svg";

const skills = [
  { name: "React", icon: react },
  { name: "Node.js", icon: node },
  { name: "Next.js", icon: next },
  { name: "Python", icon: python },
  { name: "MongoDB", icon: mongodb },
  { name: "JavaScript", icon: js },
  { name: "SQL", icon: sql },
  { name: "Blender", icon: blender },
];

export default skills;
